import apiClient from "./client";
import { normalizeItem, type MaterialItem, type RawMaterialItem } from "./materialInfo";

/** 三级分类节点（带数量） */
export interface ModelNodeWithCount {
  id: string;
  label: string;
  count: number;
}

/** 二级分类节点（带数量） */
export interface SubCategoryNodeWithCount {
  id: string;
  label: string;
  icon: string;
  count: number;
  models: ModelNodeWithCount[];
}

/** 一级分类节点（带数量） */
export interface CategoryNodeWithCount {
  id: string;
  label: string;
  tKey: string;
  icon: string;
  color: string;
  count: number;
  subCategories: SubCategoryNodeWithCount[];
}

/** 资料列表查询参数 */
export interface LibraryListParams {
  pageNumber?: number;
  pageSize?: number;
  title?: string;
  category?: string;
  modelCategory?: string;
  sortBy?: 'latest' | 'popular' | 'az';
}

/** 资料列表响应 */
export interface LibraryListResult {
  list: MaterialItem[];
  total: number;
  pageNumber: number;
  pageSize: number;
}

/** 分页查询资料列表（前台 .htm 接口） POST /agentfront/list.htm */
export async function listLibrary(params: LibraryListParams): Promise<LibraryListResult> {
  const p = new URLSearchParams();
  if (params.pageNumber) p.append("pageNumber", String(params.pageNumber));
  if (params.pageSize) p.append("pageSize", String(params.pageSize));
  if (params.title) p.append("title", params.title);
  if (params.category && params.category !== "all") p.append("category", params.category);
  if (params.modelCategory) p.append("modelCategory", params.modelCategory);
  if (params.sortBy) p.append("sortBy", params.sortBy);
  const res = await apiClient.post("/agentfront/list.htm", p);
  const d = res.data;
  if (d?.success) {
    const raw = d.data as { list: RawMaterialItem[]; total: number; pageNumber: number; pageSize: number };
    return {
      list: (raw.list ?? []).map(normalizeItem),
      total: raw.total,
      pageNumber: raw.pageNumber,
      pageSize: raw.pageSize,
    };
  }
  throw new Error(d?.info || "查询资料列表失败");
}

/** 记录资料查看日志 POST /agentfront/recordView.htm */
export async function recordMaterialView(id: string): Promise<void> {
  const p = new URLSearchParams();
  p.append("id", id);
  await apiClient.post("/agentfront/recordView.htm", p);
}

/** 获取分类树（含各分类资料数量） POST /agentfront/tree.htm */
export async function getLibraryTree(): Promise<CategoryNodeWithCount[]> {
  const res = await apiClient.post("/agentfront/tree.htm");
  const d = res.data;
  if (d?.success) {
    return (d.data as CategoryNodeWithCount[]) ?? [];
  }
  throw new Error(d?.info || "获取分类树失败");
}
